import { render, staticRenderFns } from "./ServicesProducts.vue?vue&type=template&id=732dc0ee&scoped=true"
import script from "./ServicesProducts.vue?vue&type=script&lang=js"
export * from "./ServicesProducts.vue?vue&type=script&lang=js"
import style0 from "./ServicesProducts.vue?vue&type=style&index=0&id=732dc0ee&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "732dc0ee",
  null
  
)

export default component.exports